/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AppService } from './services/app.service';
import { ContactsService } from './services/contacts.service';
import { ContactDocumentsService } from './services/contact-documents.service';
import { ContactDocumentAssetsService } from './services/contact-document-assets.service';
import { RealEstatesService } from './services/real-estates.service';
import { RealEstateDocumentsService } from './services/real-estate-documents.service';
import { CompaniesService } from './services/companies.service';
import { CompanyDocumentsService } from './services/company-documents.service';
import { SupplierPortalService } from './services/supplier-portal.service';
import { InspectionService } from './services/inspection.service';
import { EmployeesService } from './services/employees.service';
import { EmployeeDocumentsService } from './services/employee-documents.service';
import { LeadsService } from './services/leads.service';
import { LeadDocumentsService } from './services/lead-documents.service';
import { SalesService } from './services/sales.service';
import { BidDocumentsService } from './services/bid-documents.service';
import { QuotationSignService } from './services/quotation-sign.service';
import { AuditLogsService } from './services/audit-logs.service';
import { MembershipService } from './services/membership.service';
import { ScoutingService } from './services/scouting.service';
import { ScoutingDocumentsService } from './services/scouting-documents.service';
import { FileManagerService } from './services/file-manager.service';
import { SchedulerService } from './services/scheduler.service';
import { TodoService } from './services/todo.service';
import { RulesService } from './services/rules.service';
import { DeliveryService } from './services/delivery.service';
import { ChecklistsService } from './services/checklists.service';
import { ChecklistItemAttachmentsService } from './services/checklist-item-attachments.service';
import { ProjectStakeholdersService } from './services/project-stakeholders.service';
import { ProjectDocumentsService } from './services/project-documents.service';
import { ProjectZonesService } from './services/project-zones.service';
import { WorkItemsService } from './services/work-items.service';
import { ProjectProductsService } from './services/project-products.service';
import { ConstructionSitesService } from './services/construction-sites.service';
import { ConstructionSiteStakeholdersService } from './services/construction-site-stakeholders.service';
import { ConstructionSiteContractorsService } from './services/construction-site-contractors.service';
import { ConstructionSiteDocumentsService } from './services/construction-site-documents.service';
import { MediaService } from './services/media.service';
import { AnnotationsService } from './services/annotations.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AppService,
    ContactsService,
    ContactDocumentsService,
    ContactDocumentAssetsService,
    RealEstatesService,
    RealEstateDocumentsService,
    CompaniesService,
    CompanyDocumentsService,
    SupplierPortalService,
    InspectionService,
    EmployeesService,
    EmployeeDocumentsService,
    LeadsService,
    LeadDocumentsService,
    SalesService,
    BidDocumentsService,
    QuotationSignService,
    AuditLogsService,
    MembershipService,
    ScoutingService,
    ScoutingDocumentsService,
    FileManagerService,
    SchedulerService,
    TodoService,
    RulesService,
    DeliveryService,
    ChecklistsService,
    ChecklistItemAttachmentsService,
    ProjectStakeholdersService,
    ProjectDocumentsService,
    ProjectZonesService,
    WorkItemsService,
    ProjectProductsService,
    ConstructionSitesService,
    ConstructionSiteStakeholdersService,
    ConstructionSiteContractorsService,
    ConstructionSiteDocumentsService,
    MediaService,
    AnnotationsService,
    ApiConfiguration,
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
